// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  onHide: () => void,
|};

export default function MergeErrorModal({ onHide }: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('Close', 'close button')}
      accessibilityModalLabel={i18n._(
        'Board Merge Error Alert',
        'accessibility label for board merging error alert',
      )}
      onDismiss={onHide}
      heading={i18n._('Oops!', 'Modal heading for board merging confirmation modal')}
      role="alertdialog"
      size="md"
      footer={
        <Box>
          <Button
            color="red"
            text={i18n._('Got it', 'ok button in board merging error alert')}
            onClick={onHide}
          />
        </Box>
      }
    >
      <Box padding={4}>
        <Text>
          {i18n._(
            "You can't move this board because you didn't create it.",
            'board merging error alert',
          )}
        </Text>
      </Box>
    </Modal>
  );
}
